module.exports = __webpack_public_path__ + "img/situp.1ec05c3f.svg";